import { render, staticRenderFns } from "./DownloadExtensionData.vue?vue&type=template&id=11259374&scoped=true&"
import script from "./DownloadExtensionData.vue?vue&type=script&lang=js&"
export * from "./DownloadExtensionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11259374",
  null
  
)

export default component.exports